import React, { Fragment, useState, useEffect } from 'react'
import { formatNumber } from '../../../Utils/Money';

const AccountStatementSummary = ({ selectedInvoice }) => {
    const [payments, setPayments] = useState(null);
    const [valueFromPayments, setValueFromPayments] = useState(0);
    const [retentions, setRetentions] = useState(null);
    const [valueFromRetentions, setValueFromRetentions] = useState(0);
    const [totalInvoice, setTotalInvoice] = useState(0)
    const [incomeToPay, setIncomeToPay] = useState(0)

    useEffect(() => {
        //let pay = await getAllPaymentsById(selectedInvoice.id_factura_t);
        //getPaymentById(pay);
        getPaymentById(selectedInvoice.id_factura_t)

        calculateValueToPay();
    }, [])


    const getAllPaymentsById = (id_factura) => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/consultar?id_factura_t=' + id_factura, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
            })
                .then((response) => {
                    if (response.status != 500 && response.status != 403) {
                        return response.json();
                    }
                    else {
                        throw new Error(response.json());
                    }
                })
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    console.log(error)
                    reject(error);
                })
        })
    };

    const getPaymentById = async (id_factura) => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/consultar?id_factura_t=' + id_factura, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                //setPaymentsToInvoice(data);
                discriminateTypeOfPayments(data);
            })
            .catch((error) => {
                console.log(error)
            })
    };

    const discriminateTypeOfPayments = (payments) => {
        if (payments !== null && payments !== undefined) {
            let sum_payments = 0;
            let resul = payments.filter((element) => element.retencion !== true);
            resul.forEach((pay) => sum_payments += pay.importe);
            setPayments(resul);
            setValueFromPayments(sum_payments);
        }
        if (payments !== null && payments !== undefined) {
            let sum_retentions = 0
            let resul = payments.filter((element) => element.retencion !== false);
            resul.forEach((ret) => sum_retentions += ret.importe)
            setRetentions(resul);
            setValueFromRetentions(sum_retentions);
        }
    }

    const calculateTotal = (invoice) => {
        let total_tercero = 0;
        let total_abonos = 0;
        if (invoice.hasOwnProperty('servicios')) { //Factura en salud
            if (invoice.servicios !== null && invoice.servicios !== undefined) {
                if (invoice.tipo !== null) {
                    if (invoice.tipo === 1) { // cuando es particular el total de la factura es el total del copago
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.total)
                                total_abonos = 0;
                            })
                        }
                    } else { // cuando es otro regimen 
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.valor_tercero)
                                total_abonos += parseInt(recibo.total);
                            })
                        }
                    }
                }
            } else if (invoice.hasOwnProperty('detalles_comerciales')) { //Factura Comercial
                total_tercero = parseInt(invoice.detalles_comerciales?.total);
                total_abonos = parseInt(invoice.detalles_comerciales?.copago);
            } else {
                total_tercero = 0;
                total_abonos = 0;
            }
        }
        setTotalInvoice(total_tercero);
        return { ["total_tercero"]: total_tercero, ["total_abonos"]: total_abonos }
    }

    const calculateValueToPay = async () => {
        let incomeToPay = 0;
        if (selectedInvoice !== null && selectedInvoice !== undefined) {/* 
            let invoicePayments = await getAllPaymentsById(selectedInvoice.id_factura_t);
            let separatePaymentFromRetentions = invoicePayments.filter((element) => element.retencion !== true)
            let sumPayments = addPayments(separatePaymentFromRetentions);
            let separateRetentionsFromPayments = invoicePayments.filter((element) => element.retencion !== false); */
            //setRetentionsToInvoice(separateRetentionsFromPayments);
            //let sumRetentionsToInvoice = calculateRetentionsValueToInvoice(separateRetentionsFromPayments); //suma la cantidad de todas las retenciones
            //setInvoiceInfo(selectedInvoice);
            let totales_factura = calculateTotal(selectedInvoice);
            //console.log('TOTALESFAC', totales_factura);
            let valot_total_fac = totales_factura?.total_tercero;
            //setTotalInvoice(valot_total_fac)
            let valor_abonos = totales_factura?.total_abonos;
            if (valot_total_fac >= (valueFromPayments + valueFromRetentions)) {
                incomeToPay = valot_total_fac - valueFromPayments - valueFromRetentions;
                setIncomeToPay(incomeToPay);
            } else {
                setIncomeToPay('0');
            }
        }
    }

    const addPayments = (data) => {
        let acc = 0;
        data.forEach((element) => {
            acc += element.importe;
        })
        return acc;
    }

    return (
        <Fragment>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <div><h4><b>Saldo de cuenta</b></h4></div>
                <hr></hr>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                    <div><h4>Total facturado: </h4></div> <div><h4>${formatNumber(totalInvoice)} </h4></div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                    <div><h4>Total pagado: </h4></div> <div><h4>${formatNumber(valueFromPayments + valueFromRetentions)} </h4></div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                    <div><h4>Importe Adeudado: </h4></div> <div><h4>${formatNumber(totalInvoice - (valueFromPayments + valueFromRetentions))}</h4></div>
                </div>
            </div>
        </Fragment>
    )
}

export default AccountStatementSummary
